import { endpoint } from "@services/api.services";
import { TableCard } from "@ui/internal/components/card";
import { usePathname } from "@utils/hook/index.hook";
import { QueryData } from "@utils/interface/index.interface";
import { RoleData } from "@utils/interface/journey.interface";
import { useListData } from "@utils/query/index.query";
import { useMetaStore } from "@utils/states/index.state";
import { format } from "date-fns";
import { useEffect } from "react";
import { useSearchParams } from "react-router";
import { ColumnList } from "./column/index.column";
import RoleForm from "./form";

const index = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const { search, date } = useMetaStore();
  const pathname = usePathname();

  /* ================================================= api calls logic ================================================= */
  const { data, isPending, refetch, error } = useListData<QueryData<RoleData>>({
    params: {
      page: searchParams.get("tpage") || 1,
      size: searchParams.get("per") || 10,
      search,
      created_date__gte: date.from ? format(date.from, "yyyy-MM-dd") : "",
      created_date__lte: date.to ? format(date.to, "yyyy-MM-dd") : "",
      ordering: searchParams.get("ordering") || "order",
    },
    endpoint: endpoint["groups"],
    key: `${pathname}-listing`,
    window: true,
  });
  // rollback
  useEffect(() => {
    if (error?.status === 404 && error?.data?.detail === "Invalid page.") {
      searchParams.set("tpage", "1");
      setSearchParams(searchParams);
    }
  }, [error]);
  const columns = ColumnList({ refetch });

  return (
    <>
      <TableCard
        bulkActions
        table_content={{
          mode: "default",
          type: pathname,
        }}
        orientationPosition={false}
        formId={pathname}
        form={<RoleForm />}
        columns={columns}
        refetch={refetch}
        isPending={isPending}
        rows={data?.data?.results ?? []}
        sortableFilter={{
          search: search,
          ordering: searchParams.get("ordering") || "order",
        }}
        endpoint={endpoint["groups"]}
        count={data?.data?.count ?? 10}
      />
    </>
  );
};

export default index;
